export const ACCEPTANCE_COOKIE_NAME = 'aceptacionCookie'
export const MINIMUM_COOKIE_NAME = 'essentialCookies'
export const TRACKING_COOKIES_KEYS = ['_ga', '_gid', '_gat', '_gcl', '_fbp', '_fb']
export const API_TOKEN_COOKIE_NAME ='api_token'
export const ASPNET_APPLICATION_COOKIE_NAME = '.AspNet.ApplicationCookie'
export const PWA_INSTALLED_COOKIE_NAME = 'pwa_installed'
export const EVALUATE_YOUR_HEALTH_WARNING_COOKIE = 'evaluateYourHealthWarning'
export const COMPANY_CODE_INFO_MESSAGES_COOKIE_NAME = 'companyCodeInfoMessagesDismiss'
export const PRIME_BY_OPENSALUD_WARNING_COOKIE = 'primeByOpensaludWarning'
export const FOODS_DISCLAIMER_COOKIE_NAME = 'foodsDisclaimer'
export const SIMPLE_MICROHABIT_BLOCK_CLICK_DISCLAIMER_COOKIE = 'simpleMicrohabitBlockClickDisclaimer'
export const OPENSALUD_SCORECARD_COLOR_DISCLAIMER_COOKIE = 'opensaludScorecardColorDisclaimer'
export const TEST_WORK_ENVIRONMENT_DISCLAIMER_COOKIE = 'testWorkEnvironmentDisclaimer'



// WEBPACK FOOTER //
// ./src/constants/cookies.js